import { createNextTableContext } from '@core/table';

export const ModelsTableContext = createNextTableContext();
